import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfidenceBar } from "./ConfidenceBar";
const LABELS = [
    { key: "score_applicability", label: "Applicability" },
    { key: "score_legal_stability", label: "Legal stability" },
    { key: "score_recoverability", label: "Recoverability" },
    { key: "score_limitation", label: "Limitation" },
];
export function hasOntologyScores(values) {
    return LABELS.some(({ key }) => values[key] != null);
}
export function OntologyScores({ values, className = "" }) {
    if (!hasOntologyScores(values))
        return null;
    return (_jsx("div", { className: ["grid grid-cols-1 gap-4 sm:grid-cols-2", className].join(" "), children: LABELS.map(({ key, label }) => {
            const score = values[key];
            if (typeof score !== "number")
                return null;
            return (_jsxs("div", { children: [_jsx("div", { className: "mb-1 text-xs font-medium text-slate-500", children: label }), _jsx(ConfidenceBar, { value: Math.round(score * 100) })] }, key));
        }) }));
}
